import { createStyle } from '@gluestack-style/react';

export const AccordionIcon = createStyle({
  props: {
    size: 'md',
  },
});
